import * as React from 'react'
import { observer } from 'mobx-react'
import { modalStore } from '../../../shared'
import { collectionsStore } from '../../collections.store'
import { ITabsModalProps } from '../tabs.interfaces'
import './tabs-cart-modal.scss'

@observer
export class TabsCartModal extends React.Component<ITabsModalProps> {
  baseClass: string = 'tabs-cart-modal'

  render(): React.ReactNode {
    const { activeDepartment: active } = collectionsStore

    return (
      <div className={this.baseClass} style={{ padding: '30px' }}>
        <h3>You have {active.id} items in your cart</h3>
        <div className={`${this.baseClass}__card-wrapper`}>
          <div className={`${this.baseClass}__card`}>
            <img className={`${this.baseClass}__card__img`} src={active.image} />
            <button
              className="btn"
              id="keep-shopping"
              onClick={(): void => modalStore.toggle()}
            >
              Keep shopping {active.id}
            </button>
          </div>
          <span className={`${this.baseClass}__separator`} />
          <div className={`${this.baseClass}__card`}>
            <img className={`${this.baseClass}__card__img`} src={""} />
            <button
              className="btn"
              id="clear-cart-proceed"
              onClick={this.props.proceed}
            >
              Clear cart and shop
            </button>
          </div>
        </div>
      </div>
    )
  }
}
